// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';
import {
  dummySlaRiskTimes,
  dummyAutoAlerts,
  dummyCriticalWords,
} from '../pages/calificaciones/sla/mappers/SlaMapper';

const http = new AxiosAdapter();

export const getSlaService = async () => {
  try {
    // return { ok: true, data: { slaTimes: dummySlaRiskTimes, autoAlerts: dummyAutoAlerts, criticalWords: dummyCriticalWords } };
    return await http.get<any>(`/v1/risk-levels`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }

    console.log('getSlaService ', error);
  }
};

export const createSlaService = async (slaData: object) => {
  try {
    return await http.postLogin<any>(`/v1/risk-levels`, slaData);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createSlaService ', error);
  }
};

export const updateSlaService = async (slaData: object) => {
  try {
    return await http.put<any>(`/v1/risk-levels`, slaData);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateSlaService ', error);
  }
};

export const createAutoAlertService = async (alertData: object) => {
  try {
    return await http.postLogin<any>(`/v1/alert-risk-level-triggers`, alertData);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createAutoAlertService ', error);
  }
};

export const updateAutoAlertService = async (id: string, alertData: object) => {
  try {
    return await http.put<any>(`/v1/alert-risk-level-triggers/${id}`, alertData);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateAutoAlertService ', error);
  }
};

export const deleteAutoAlertService = async (id: string) => {
  try {
    return await http.delete<any>(`/v1/alert-risk-level-triggers/${id}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('deleteAutoAlertService ', error);
  }
};

export const createAlertKeywordService = async (keywordData: object) => {
  try {
    return await http.postLogin<any>(`/v1/alert-keywords`, keywordData);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createAlertKeywordService ', error);
  }
};

export const deleteAlertKeywordService = async (id: string) => {
  try {
    return await http.delete<any>(`/v1/alert-keywords/${id}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('deleteAlertKeywordService ', error);
  }
};
